var map = {
	"./en/companyAccount.json": 21074,
	"./es/companyAccount.json": 3888,
	"./fr/companyAccount.json": 93197,
	"./it/companyAccount.json": 52615,
	"./pt-BR/companyAccount.json": 18135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5278;